import CarotekColors from "@carotek/utils/Colors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

Object.assign(filterListStyles, {
    ...filterListStyles,
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            background-color: ${CarotekColors.grey8};
            border: 1px solid ${CarotekColors.grey3};
            padding: 4px 15px;
        `,
    },
    filterText: {
        variant: "h3",
        fontFamily: "Neuron",
    },

    clearAllLink: {
        typographyProps: {
            size: 14,
        },
        css: css`
            padding-bottom: 15px;
        `,
    },
    filterTag: {
        typographyProps: {
            size: 14,
            color: `${CarotekColors.grey9}`,
            css: css`
                padding-right: 0;
                :hover {
                    text-decoration: underline;
                    cursor: pointer;
                }
            `,
        },
        iconProps: {
            size: 14,
            css: css`
                background-color: transparent;
            `,
        },
        css: css`
            background-color: transparent;
            border-color: transparent;
            flex-direction: row-reverse;
            justify-content: flex-end;
            padding: 0;
            margin-bottom: 20px;
            max-width: 265px;
            margin-right: 0;
            min-height: auto;
            [class^="ButtonWrapper"] {
                background-color: transparent;
                transform: translateY(4px);
                margin-right: 10px;
                min-height: auto;
            }
        `,
    },
});
